<template>
  <div class="overall-bg">
    <b-container fluid="xl">
      <b-row class="pt-3">
        <b-col lg="6" class="d-flex align-items-center">
          <BacktoPage :backlist="false" path="/Masters" @clickclear="isClear()" />

          <div v-if="status == '1'" class="d-flex align-items-center">
            <div class="main-header-store">MS</div>
            <div>
              <p class="storecode">{{ StoreCode }}</p>
              <p class="common-heading1">{{ paramValues.storename }}</p>
            </div>
          </div>

          <div v-if="status == '2'" class="d-flex align-items-center">
            <div class="sub-header-store">SS</div>
            <div>
              <p class="storecode">{{ StoreCode }}</p>
              <p class="common-heading1">{{ paramValues.storename }}</p>
            </div>
          </div>

          <div v-if="status == '3'" class="d-flex align-items-center">
            <div class="dept-header-store">DS</div>
            <div>
              <p class="storecode">{{ StoreCode }}</p>
              <p class="common-heading1">{{ paramValues.storename }}</p>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
  <div class="overall-bg p-0 header-top">
    <section>
      <b-container class="storetabdetails">
        <div class="tab-container d-flex align-items-center">
          <TabView class="tabview-custom transaction-tabs position-relative" v-model:activeIndex="clases" ref="tabview4"
            @keyup.enter="handleKeyDown" :scrollable="false">
            <TabPanel v-for="(tab, index) in TabArray" :key="index">
              <template #header>
                <div class="d-flex align-items-center settabheight" @click="TabClick(tab, index), TabGetIndex(index)">
                  <img :src="tab.Image" class="DetailsIcon" />
                  <span style="padding: 0px 7px">{{
                    $t(`${tab["Path"]}`)
                  }}</span>
                </div>
              </template>

              <div v-if="activeTabIndex == index">
                <component :is="tab.FixedHref" :propsParams="paramValues" :FunctionRights="functionRights"
                  :Addstatus="false" :tstatus="false" @StoreCode="storeCode" @itemIssue="RoutetoItemISsue" />
              </div>
            </TabPanel>
           
          </TabView>

          <div class="overflow-menu" v-show="overflowTabs.length > 0">
            <button class="ellipsis-btn" @click="toggleDropdown">
              <i class="pi pi-ellipsis-h"></i>
            </button>
            <div v-if="showDropdown" class="overflow-dropdown">
              <div v-for="tab in overflowTabs" :key="tab.Path" class="dropdown-item"
                @click="selectOverflowTab(tab, TabArray.indexOf(tab))">
                <div class="d-flex align-items-center">
                  <img :src="tab.Image" class="DetailsIcon me-2" />
                  <span>{{ $t(tab.Path) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-container>
    </section>
  </div>
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  computed,
  onMounted,
  watch,
  onUnmounted,
  nextTick,
} from "vue";
import { useRoute } from "vue-router";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import Headerlayout from "../../../../components/Masters/HeaderLayout.vue";
import Details from "../../../../modules/Inventory/components/MasterDetails/Details.vue";
import Documents from "../../../../modules/Inventory/components/MasterDetails/Documentation.vue";
import MemberDetails from "../../../../modules/Inventory/components/MasterDetails/MemberDetails.vue";
import Log from "../../../../modules/Inventory/components/MasterDetails/TabsPage/Log.vue";
import POTableview from "../../../../modules/Inventory/pages/Transaction/PurchaseOrder/POTable.vue";
import RequestTable from "../../../../modules/Inventory/pages/Transaction/stockwithoutaffect/Request/RequestTable.vue";
import PITable from "../../../../modules/Inventory/pages/Transaction/PurchaseIndent/PurchaseIndentTable.vue";
import IssueTable from "../../../../modules/Inventory/pages/Transaction/StockOut/issuereturn/ItemIssueTable.vue";
import GrnTable from "../../../../modules/Inventory/pages/Transaction/stockin/grn/GrnTable.vue";
import PurchaseIndentTableVue from "../../../../modules/Inventory/pages/Transaction/PurchaseIndent/PurchaseIndentTable.vue";
import POAmmendmentTableview from "../../../../modules/Inventory/pages/Transaction/POAmmendment/POAmmendmentTableview.vue";
import DetailsTableview from "../../../../modules/Inventory/pages/Masters/Items/ItemMaster/DetailsTableview.vue";
import QuotesTableview from "../../../../modules/Inventory/pages/Transaction/stockwithoutaffect/quotes/QuotesTab.vue";
import InboundRequestTableview from "../../../../modules/Inventory/pages/Transaction/stockwithoutaffect/Request/inboundrequest/InboundRequestTableview.vue";
import OutboundRequestTableview from "../../pages/Transaction/stockwithoutaffect/Request/outboundrequest/OutboundRequestTableview.vue";
import InBoundIssueTableView from "../../../../modules/Inventory/pages/Transaction/stockin/issue/InBoundIssue/InBoundIssueTableView.vue";
import OutBoundIssueTableView from "../../../../modules/Inventory/pages/Transaction/StockOut/issuereturn/OutBoundIssue/OutBoundIssueTableView.vue";
import ItemStoreMappingTblview from "../Masters/Items/StoreMappingItemCategory/ItemStoreMappingTblview.vue";
import ConsumptionTable from "../../../../modules/Inventory/pages/Transaction/StockOut/consumption/ConsumptionTable.vue";
import StoreCategoryMappingTblview from "../Masters/ItemCategory/StoreCategoryMapping/StoreCategoryMappingTblview.vue";
import MastersService from "../../Service/MastersService";
import BacktoPage from "../../../../components/FormComponents/BacktoMaster.vue";
import PurchaseRequestTable from "../../../../modules/Inventory/pages/Transaction/PurchaseRequest/purchaseRequestTable.vue";
import ReorderTableView from "../../../../modules/Inventory/pages/Transaction/ReOrderLevel/reOrderLevelTableview.vue";
import RateContractTableview from "../../../../modules/Inventory/pages/Transaction/RateContract/RateContractTableview.vue";
import Reports from "../../../../modules/Inventory/pages/Reports/Reports.vue";
import Users from "../../../../modules/Inventory/components/MasterDetails/Users.vue";
import ClosingStockTable from "../../../../modules/Inventory/pages/Transaction/ClosingStockTable.vue";
import { useInventoryStore } from "../../../../modules/Inventory/stores/Index";
import Payment from "../../../../modules/Inventory/pages/Transaction/Payment/SupplierPayment/SupplierPaymentTable.vue";
import AssetDashboard from "../../../../modules/Inventory/pages/AssetManagement/Transaction/view/AssetDashboard/AssetDashboard.vue";
import ItemAssets from "../../../../modules/Inventory/pages/AssetManagement/Transaction/view/AssetInitialSetup/ItemAssetTable.vue";
import Deployment from "../../../../modules/Inventory/pages/AssetManagement/Transaction/view/Deployment/DeploymentTable.vue";
import Disposal from "../../../../modules/Inventory/pages/AssetManagement/Transaction/view/Disposal/Disposal.vue";
import PaymentDashboard from "../../../../modules/Inventory/pages/Dashboard/PaymentDashboard.vue";
import TallyPosting from "../../../../modules/Inventory/pages/Transaction/Tally/TallyPosting.vue";
import MaintenanceScheduleTableView from "../AssetManagement/Transaction/view/AssetMaintenanceDashboard/AssetMaintenanceDashboard.vue";
import EscalateTableView from "../AssetManagement/Transaction/view/AssetEscalation/AssetEscalationTableView.vue";
import NewMaintenanceScheduleTableView from "../AssetManagement/Transaction/view/AssetMaintenanceNew/AssetMaintenanceTable.vue";
import AssetServiceTableView from "../AssetManagement/Transaction/view/AssetService/AssetServiceTableView.vue";
import GatePassTableView from "../AssetManagement/Transaction/view/GatePass/GatePassTableView.vue";
interface TabItem {
  Path: string;
  Image: string;
  EntityId: number;
  FixedHref: string;
  StoreRights: string;
}

export default defineComponent({
  components: {
    Documents,
    ItemStoreMappingTblview,
    OutboundRequestTableview,
    InboundRequestTableview,
    QuotesTableview,
    DetailsTableview,
    POAmmendmentTableview,
    POTableview,
    Details,
    MemberDetails,
    Log,
    Headerlayout,
    PurchaseIndentTableVue,
    RequestTable,
    PITable,
    IssueTable,
    GrnTable,
    OutBoundIssueTableView,
    InBoundIssueTableView,
    ConsumptionTable,
    StoreCategoryMappingTblview,
    BacktoPage,
    PurchaseRequestTable,
    RateContractTableview,
    Reports,
    Users,
    ClosingStockTable,
    ReorderTableView,
    Payment,
    AssetDashboard,
    ItemAssets,
    Deployment,
    Disposal,
    PaymentDashboard,
    TallyPosting,
    MaintenanceScheduleTableView,
    NewMaintenanceScheduleTableView,
    EscalateTableView,
    AssetServiceTableView,
    GatePassTableView
  },
  props: {
    showDetailsTab: {
      readonly: false,
      type: Boolean,
      default: false,
    },
    showItemsTab: {
      readonly: false,
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const { t } = useI18n();
    const clases = ref(0);
    const inventoryStore = useInventoryStore();
    const tabview4 = ref<any>(null);

    const menuarray = ref<TabItem[]>([]);
    const TabArray = ref<TabItem[]>([]);
    const activeTabIndex = ref(0);

    const showDropdown = ref(false);
    const containerWidth = ref(0);
    const tabWidths = ref<number[]>([]);
    const overflowTabs = ref<TabItem[]>([]);
    const resizeObserver = ref<ResizeObserver | null>(null);

    const calculateVisibleTabs = () => {
      if (!tabview4.value) return;

      const container = tabview4.value.$el.querySelector(
        ".p-tabview-nav-content"
      );
      if (!container) return;

      // Get container width with extra buffer for stability
      const style = window.getComputedStyle(container);
      const horizontalPadding =
        parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
      const ellipsisWidth = 60; // Increased buffer for ellipsis button
      const safetyBuffer = 20; // Additional buffer for stability
      containerWidth.value =
        container.clientWidth -
        horizontalPadding -
        ellipsisWidth -
        safetyBuffer;

      const tabs = container.querySelectorAll(".p-tabview-nav li");
      if (!tabs.length) return;

      // Collect all tab widths with small buffer
      const newTabWidths: number[] = [];
      let totalWidth = 0;

      tabs.forEach((tab: Element) => {
        const width = tab.getBoundingClientRect().width + 2; // Small buffer per tab
        newTabWidths.push(width);
        totalWidth += width;
      });

      tabWidths.value = newTabWidths;

      // If all tabs fit, no need for overflow
      if (totalWidth <= containerWidth.value) {
        overflowTabs.value = [];
        showDropdown.value = false;
        return;
      }

      const activeIndex = clases.value;

      // Always ensure active tab is visible
      let visibleTabs = new Set<number>([activeIndex]);
      let availableWidth = containerWidth.value - tabWidths.value[activeIndex];

      // Try to show tabs before active tab
      for (let i = activeIndex - 1; i >= 0; i--) {
        if (availableWidth - tabWidths.value[i] >= 0) {
          visibleTabs.add(i);
          availableWidth -= tabWidths.value[i];
        } else {
          break;
        }
      }

      // Then try to show tabs after active tab
      for (let i = activeIndex + 1; i < tabs.length; i++) {
        if (availableWidth - tabWidths.value[i] >= 0) {
          visibleTabs.add(i);
          availableWidth -= tabWidths.value[i];
        } else {
          break;
        }
      }

      // All non-visible tabs go to overflow
      overflowTabs.value = TabArray.value.filter(
        (_, index) => !visibleTabs.has(index)
      );

      // Only show the ellipsis button, but don't auto-open the dropdown
      showDropdown.value = false;

      // Debug logging
      console.log("Active tab:", activeIndex);
      console.log("Visible tabs:", Array.from(visibleTabs));
      console.log("Overflow tabs:", overflowTabs.value.length);
      console.log("Container width:", containerWidth.value);
      console.log("Total width:", totalWidth);
    };

    const toggleDropdown = () => {
      if (overflowTabs.value.length > 0) {
        showDropdown.value = !showDropdown.value;
      }
    };

    const selectOverflowTab = (tab: TabItem, index: number) => {
      // Update active tab
      clases.value = index;
      activeTabIndex.value = index;

      // Close dropdown
      showDropdown.value = false;

      // Trigger tab click
      TabClick(tab, index);

      // Recalculate after tab switch
      nextTick(() => {
        calculateVisibleTabs();
      });
    };

    // Handle click outside to close dropdown
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      if (!target.closest(".overflow-menu")) {
        showDropdown.value = false;
      }
    };

    onMounted(() => {
      paramValues.value.Id = String(route.query.Id);
      paramValues.value.Type = route.query.Type as string;
      paramValues.value.status = Number(route.query.status);
      paramValues.value.storename = route.query.storename as string;
      paramValues.value.storebranchmapid = Number(route.query.storebranchmapid);
      LoadMenus();

      let TabIndexval = localStorage.getItem("TabIndex");
      let TabIndexvalDataData;
      if (TabIndexval !== null) {
        TabIndexvalDataData = JSON.parse(TabIndexval);
        clases.value = TabIndexvalDataData.Indexval;
        activeTabIndex.value = TabIndexvalDataData.Indexval;
      }

      // Add click outside listener
      document.addEventListener("click", handleClickOutside);

      // Initialize ResizeObserver
      resizeObserver.value = new ResizeObserver(() => {
        calculateVisibleTabs();
      });

      // Start observing after a short delay to ensure DOM is ready
      setTimeout(() => {
        if (tabview4.value && resizeObserver.value) {
          const container = tabview4.value.$el.querySelector(
            ".p-tabview-nav-content"
          );
          if (container) {
            resizeObserver.value.observe(container);

            // Initial state setup with multiple calculation points
            const setupSequence = () => {
              calculateVisibleTabs();
            };

            // Multiple calculation points with increasing delays
            setupSequence();
            setTimeout(setupSequence, 100);
            setTimeout(setupSequence, 300);
            setTimeout(setupSequence, 500);

            // Final check after all animations complete
            setTimeout(setupSequence, 1000);
          }
        }
      }, 100);
    });

    onUnmounted(() => {
      // Remove click outside listener
      document.removeEventListener("click", handleClickOutside);

      // Cleanup ResizeObserver
      if (resizeObserver.value) {
        resizeObserver.value.disconnect();
      }
    });

    let status = computed(() => {
      return route.query.status;
    });

    const paramValues = ref({
      Id: "",
      Type: "",
      status: 0,
      storename: "",
      storebranchmapid: 0,
    });

    let StoreCode = ref<string>();
    const storeCode = (data: string) => {
      StoreCode.value = data;
    };

    //get local storage session data
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }

    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }

    watch(
      () => inventoryStore.MenuTab,
      (newVal: any) => {
        if (inventoryStore.MenuTab != null) {
          let WatchEntityId = {
            EntityId:
              inventoryStore.MenuTab == 157 || inventoryStore.MenuTab == 158
                ? 132
                : inventoryStore.MenuTab,
          };
          let index = 0;
          if (inventoryStore.MenuTab == 157 || inventoryStore.MenuTab == 158) {
            inventoryStore.SubTab = inventoryStore.MenuTab;
            index = 3;
          } else if (inventoryStore.MenuTab == 145) {
            index = 7;
          } else if (inventoryStore.MenuTab == 136) {
            index = 8;
          } else if (inventoryStore.MenuTab == 313) {
            index = 5;
          }
          TabClick(WatchEntityId, index);
          TabGetIndex(index);
        }
      }
    );

    watch(
      () => route.query.Id,
      (newVal: any) => {
        paramValues.value.Id = newVal;
        paramValues.value.Type = route.query.Type as string;
        paramValues.value.status = Number(route.query.status);
        paramValues.value.storename = route.query.storename as string;
        paramValues.value.storebranchmapid = Number(
          route.query.storebranchmapid
        );
        LoadMenus();

        clases.value = 0;
        let TabIndexval = localStorage.getItem("TabIndex");
        let TabIndexvalDataData;
        if (TabIndexval !== null) {
          TabIndexvalDataData = JSON.parse(TabIndexval);
        }
        clases.value = TabIndexvalDataData.Indexval;
        activeTabIndex.value = TabIndexvalDataData.Indexval;
      }
    );

    async function LoadMenus() {
      let response = await MastersService.GetMenus(
        2,
        rolesData.RoleId,
        usersData.OrganizationId
      );

      console.log("MenuListStoreTabDetails", response["result"]);
      menuarray.value = response["result"];
      BindTabsByStore(menuarray.value);
    }

    function BindTabsByStore(MenuArray: TabItem[]) {
      TabArray.value = MenuArray.filter((item) =>
        item.StoreRights.split(",").includes(route.query.status as string)
      );

      console.log(route.query.status);
      console.log(TabArray.value);

      if (TabArray.value.length > 0) {
        let TabIndexval = localStorage.getItem("TabIndex");
        let TabIndexvalDataData;
        if (TabIndexval !== null) {
          TabIndexvalDataData = JSON.parse(TabIndexval);
        }
        if (clases.value !== 0) {
          TabIndexvalDataData.Indexval = clases.value;
        } else {
          TabIndexvalDataData.Indexval = clases.value;
        }
        console.log("Tabarray", TabArray.value);
        TabClick(
          TabArray.value[TabIndexvalDataData.Indexval],
          TabIndexvalDataData.Indexval
        );

        // Calculate visible tabs after binding
        setTimeout(calculateVisibleTabs, 100);
      }
    }

    let functionRights = ref({
      Create: false,
      Update: false,
      Read: false,
      Delete: false,
      CreateId: 0,
      UpdateId: 0,
      ReadId: 0,
      DeleteId: 0,
      EntityId: 0,
    });

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "ArrowLeft" && clases.value > 0) {
        clases.value--;
      } else if (
        event.key === "ArrowRight" &&
        clases.value < TabArray.value.length - 1
      ) {
        clases.value++;
      }
      activeTabIndex.value = clases.value;
    };

    function TabGetIndex(index: number) {
      activeTabIndex.value = index;
      clases.value = index;

      // Recalculate overflow tabs after index change
      nextTick(calculateVisibleTabs);
    }

    async function TabClick(SubMenuDetails: any, index: number) {
      const wasDropdownVisible = showDropdown.value;
      console.log("SubMenuEntityId", SubMenuDetails.EntityId);
      let InstantEntityId = {
        EntityId: SubMenuDetails.EntityId,
      };
      localStorage.removeItem("EntityData");
      localStorage.setItem("EntityData", JSON.stringify(InstantEntityId));

      let TabIndex = {
        Indexval: index,
      };
      localStorage.removeItem("TabIndex");
      localStorage.setItem("TabIndex", JSON.stringify(TabIndex));

      let TabIndexval = localStorage.getItem("RequestSubTabIndex");
      let TabIndexvalDataData;
      if (TabIndexval !== null) {
        TabIndexvalDataData = JSON.parse(TabIndexval);
      }
      let TabIndexIssueval = localStorage.getItem("ItemIssueSubTabIndex");
      let TabIndexIssuevalDataData;
      if (TabIndexIssueval !== null) {
        TabIndexIssuevalDataData = JSON.parse(TabIndexIssueval);
      }

      if (
        SubMenuDetails["FixedHref"] == "RequestTable" &&
        TabIndexvalDataData?.Indexval
      ) {
        let TabIndex = {
          Indexval: TabIndexvalDataData.Indexval,
        };
        localStorage.removeItem("RequestSubTabIndex");
        localStorage.setItem("RequestSubTabIndex", JSON.stringify(TabIndex));
      }
      if (SubMenuDetails["FixedHref"] == "IssueTable") {
        let TabIndex = {
          Indexval: TabIndexIssuevalDataData?.Indexval,
        };
        localStorage.removeItem("ItemIssueSubTabIndex");
        localStorage.setItem("ItemIssueSubTabIndex", JSON.stringify(TabIndex));
      } else {
        let TabIndex = {
          Indexval: 0,
        };
        localStorage.removeItem("ItemIssueSubTabIndex");
        localStorage.setItem("ItemIssueSubTabIndex", JSON.stringify(TabIndex));
      }

      const response = await MastersService.CheckMenuRights(
        InstantEntityId.EntityId,
        rolesData.RoleId
      );
      console.log(response["result"]);

      let Rights = ref({
        Create: false,
        Update: false,
        Read: false,
        Delete: false,
      });

      for (let i = 0; i < response["result"].length; i++) {
        const operation = response["result"][i];
        if (operation.OperationName === "Create") {
          functionRights.value.CreateId = operation.OperationID;
          Rights.value.Create = operation.IsActive;
        } else if (operation.OperationName === "Update") {
          functionRights.value.UpdateId = operation.OperationID;
          Rights.value.Update = operation.IsActive;
        } else if (operation.OperationName === "Read") {
          functionRights.value.ReadId = operation.OperationID;
          Rights.value.Read = operation.IsActive;
        } else if (operation.OperationName === "Delete") {
          functionRights.value.DeleteId = operation.OperationID;
          Rights.value.Delete = operation.IsActive;
        }
      }
      functionRights.value.EntityId = InstantEntityId.EntityId;
      functionRights.value.Create = Rights.value.Create;
      functionRights.value.Update = Rights.value.Update;
      functionRights.value.Read = Rights.value.Read;
      functionRights.value.Delete = Rights.value.Delete;

      // Recalculate overflow tabs after tab switch
      nextTick(() => {
        calculateVisibleTabs();
        // Always close dropdown when switching tabs
        showDropdown.value = false;
      });
    }

    function isClear() {
      // localStorage.removeItem("TabIndex");
    }

    function RoutetoItemISsue() {
      debugger;
      let TabIndexval = localStorage.getItem("TabIndex");
      let TabIndexvalDataData;
      if (TabIndexval !== null) {
        TabIndexvalDataData = JSON.parse(TabIndexval);
      }
      clases.value = TabIndexvalDataData.Indexval;

      let data = TabArray.value[clases.value];
      TabClick(data, clases.value);
      TabGetIndex(clases.value);
    }

    return {
      isClear,
      clases,
      status,
      paramValues,
      menuarray,
      TabClick,
      TabGetIndex,
      functionRights,
      TabArray,
      activeTabIndex,
      handleKeyDown,
      storeCode,
      StoreCode,
      showDropdown,
      toggleDropdown,
      selectOverflowTab,
      tabview4,
      overflowTabs,
      $t: t,
      RoutetoItemISsue,
    };
  },
});
</script>

<style lang="scss">
.p-tabview-header span {
  white-space: nowrap;
}

.tabview-custom {
  width: 99%;
}

.DetailsIcon {
  height: 1rem;
  font-weight: 300;
  filter: brightness(10) invert(0) !important;
  opacity: 0.5;
}

.storecode {
  color: #999999;
  font-size: 12px;
}

.main-store {
  font-size: 10px;
  border-radius: 50%;
  background-color: #cdd0fb;
  padding: 10px;
  margin-right: 10px;
}

.sub-store {
  background-color: #fff3cc;
  font-size: 10px;
  border-radius: 50%;
  padding: 10px;
  margin-right: 10px;
}

.dept-store {
  font-size: 10px;
  border-radius: 50%;
  background-color: #ffcccc;
  padding: 10px;
  margin-right: 10px;
}

.storetabdetails .p-tabview-nav-btn {
  display: none;
}

.storetabdetails .p-tabview-nav-content {
  border-bottom: 1px solid #e1e1e1;
}

.storetabdetails .p-tabview .p-tabview-nav {
  padding: 0 15px !important;
  background: #f9f9f9 !important;
  display: flex;
  align-items: center;
  min-height: 40px;
  border-bottom: 1px solid #e1e1e1;
}

.storetabdetails .p-tabview .p-tabview-nav-container {
  overflow: visible !important;
}

.storetabdetails .p-tabview .p-tabview-nav li {
  margin-right: -3px !important;
  background: #f9f9f9;
}

.storetabdetails .p-tabview .p-tabview-nav li .p-tabview-nav-link {
  background: transparent !important;
  color: #000000 !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  border: none !important;
}

.storetabdetails .p-tabview-nav img {
  filter: brightness(0) invert(0) !important;
}

.storetabdetails .p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link,
.storetabdetails .p-tabview .p-tabview-nav li:focus-within {
  color: #296cb0 !important;
}

.storetabdetails .p-tabview .p-tabview-nav .p-highlight,
.storetabdetails .p-tabview .p-tabview-nav .p-tabview-header:hover,
.storetabdetails .p-tabview .p-tabview-nav li:focus-within {
  margin-right: 0px !important;
  color: white !important;
  transition: margin-inline 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
}

.storetabdetails .p-tabview-nav .p-highlight span,
.storetabdetails .p-tabview-nav .p-highlight div,
.storetabdetails .p-tabview-nav .p-highlight p,
.storetabdetails .p-tabview-nav .p-highlight .pi {
  color: #296cb0 !important;
  font-weight: 500;
}

.storetabdetails .p-tabview-nav .p-highlight .DetailsIcon,
.storetabdetails .p-tabview .p-tabview-nav .p-tabview-header:hover .DetailsIcon {
  filter: brightness(10) invert(10) !important;
  color: white !important;
}

.tab-container {
  position: relative;
  width: 100%;
}

.overflow-menu {
  position: absolute;
  top: 0;
  right: -4%;
  height: 40px;
  display: flex;
  align-items: center;
  border-left: 1px solid rgba(41, 108, 176, 0.15);
  padding-left: 12px;
  transition: all 0.2s ease;
}

.ellipsis-btn {
  width: 36px;
  height: 36px;
  background: transparent;
  border: none;
  color: #296cb0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0;
  border-radius: 6px;
  background: rgba(41, 108, 176, 0.08);
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;

  &::after {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: 6px;
    box-shadow: 0 0 0 2px rgba(41, 108, 176, 0);
    transition: all 0.2s ease;
  }

  &:hover {
    background: rgba(41, 108, 176, 0.12);
  }

  &:active {
    transform: translateY(1px);

    &::after {
      box-shadow: 0 0 0 2px rgba(41, 108, 176, 0.2);
    }
  }

  .pi {
    font-size: 1.25rem;
    transition: transform 0.2s ease;
  }
}

.overflow-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  background: white;
  border: 1px solid rgba(41, 108, 176, 0.12);
  border-radius: 12px;
  box-shadow: 0 12px 24px -6px rgba(0, 0, 0, 0.12),
    0 6px 12px -3px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(41, 108, 176, 0.08);
  min-width: 280px;
  z-index: 1000;
  padding: 8px;
  margin-top: 4px;
  max-height: 400px;
  overflow-y: auto;
  transform-origin: top right;
  animation: dropdownEnter 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);

  @keyframes dropdownEnter {
    0% {
      opacity: 0;
      transform: translateY(-12px) scale(0.95);
    }

    40% {
      opacity: 1;
    }

    100% {
      transform: translateY(0) scale(1);
    }
  }

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(41, 108, 176, 0.2);
    border-radius: 4px;

    &:hover {
      background: rgba(41, 108, 176, 0.3);
    }
  }
}

.dropdown-item {
  padding: 12px 16px;
  margin: 4px 0;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
  display: flex;
  align-items: center;
  border-radius: 8px;
  position: relative;
  overflow: hidden;
  background: transparent;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(120deg,
        rgba(41, 108, 176, 0.08),
        rgba(41, 108, 176, 0.04) 30%,
        rgba(41, 108, 176, 0.02) 70%,
        rgba(41, 108, 176, 0.08) 100%);
    opacity: 0;
    transition: all 0.4s ease;
    transform: translateX(-100%);
  }

  &:hover {
    &::before {
      opacity: 1;
    }

    .DetailsIcon {
      opacity: 1;
      filter: brightness(0) saturate(100%) invert(32%) sepia(98%) saturate(1369%) hue-rotate(194deg) brightness(97%) contrast(96%) !important;
    }

    span {
      color: #296cb0;
      transform: translateX(4px);
      font-weight: 600;
      letter-spacing: 0.01em;
    }
  }

  &:active {
    transform: translateX(2px) scale(0.98);
    transition: all 0.2s cubic-bezier(0.34, 1.56, 0.64, 1);

    &::before {
      opacity: 0.6;
      transition: all 0.2s ease;
    }

    .DetailsIcon {
      transform: scale(0.92) rotate(4deg);
      transition: all 0.2s ease;
    }
  }

  .DetailsIcon {
    width: 18px;
    height: 18px;
    margin-right: 14px;
    filter: brightness(0) saturate(100%) !important;
    opacity: 0.7;
    transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
    transform-origin: center;
  }

  span {
    color: #333;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  }

  &:hover {
    .DetailsIcon {
      opacity: 1;
      filter: brightness(0) saturate(100%) invert(32%) sepia(98%) saturate(1369%) hue-rotate(194deg) brightness(97%) contrast(96%) !important;
    }

    span {
      color: #296cb0;
    }
  }
}

// Override the filter for dropdown icons to match tabs
.overflow-dropdown .dropdown-item .DetailsIcon {
  filter: brightness(0) saturate(100%) !important;
  opacity: 0.7;
}

.overflow-dropdown .dropdown-item:hover .DetailsIcon {
  filter: brightness(0) saturate(100%) invert(32%) sepia(98%) saturate(1369%) hue-rotate(194deg) brightness(97%) contrast(96%) !important;
  opacity: 1;
}

.tab-container {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
}

.tabview-custom {
  flex: 1;
  min-width: 0;
}
</style>
